module.exports = __webpack_public_path__ + "351435f0118c6b72b58341862e274119.svg";